import { jsx as r } from "react/jsx-runtime";
import { tv as x } from "tailwind-variants";
const c = x({
  base: [],
  variants: {
    level: {
      1: ["font-secondary", "text-3xl", "tablet:text-5xl"],
      2: ["font-bold", "font-primary", "tracking-widest", "uppercase"],
      3: ["font-secondary", "text-2xl", "tablet:text-4xl"],
      4: ["font-secondary", "text-xl", "tablet:text-2xl"],
      5: ["font-secondary", "text-xl"],
      6: ["font-secondary", "text-lg"]
    }
  }
}), d = ({
  children: e,
  className: a,
  id: n,
  level: t = "1",
  tagName: o,
  ...s
}) => {
  const l = o || `h${t}`;
  return /* @__PURE__ */ r(l, { ...s, className: c({ class: a, level: t }), id: n, children: e });
};
d.displayName = "Heading";
export {
  d as H
};
